'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'bug';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'f188';
var svgPathData = 'M288 0c-53 0-96 43-96 96l0 3.6c0 15.7 12.7 28.4 28.4 28.4l135.1 0c15.7 0 28.4-12.7 28.4-28.4l0-3.6c0-53-43-96-96-96zM400 280l0 72c0 53.6-37.7 98.4-88 109.4L312 296c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 165.4c-50.3-11-88-55.8-88-109.4l0-72c0-30.9 25.1-56 56-56l112 0c30.9 0 56 25.1 56 56zM147.8 218.9c-9.5 13.1-16 28.4-18.6 45.1L24 264c-13.3 0-24 10.7-24 24s10.7 24 24 24l104 0 0 40c0 6.5 .4 12.9 1.1 19.1L41.6 436.8c-10.6 8-12.8 23-4.8 33.6s23 12.8 33.6 4.8l73-54.7C169 474.6 224.1 512 288 512s119-37.4 144.6-91.5l73 54.7c10.6 8 25.6 5.8 33.6-4.8s5.8-25.6-4.8-33.6l-87.5-65.7c.7-6.3 1.1-12.7 1.1-19.1l0-40 104 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-105.2 0c-2.6-16.7-9.1-32-18.6-45.1l106.2-79.7c10.6-8 12.8-23 4.8-33.6s-23-12.8-33.6-4.8L390.6 187c-14-7.1-29.9-11-46.6-11l-112 0c-16.8 0-32.6 4-46.6 11l-115-86.2c-10.6-8-25.6-5.8-33.6 4.8s-5.8 25.6 4.8 33.6l106.2 79.7z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBug = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;